import { Flow_Condition__Input } from '~/graphql/types';

const asFlowConditionAppVBOWaardecheckAppraisalRequestNewInput =
  (): Flow_Condition__Input => ({
    EventContactApp: {
      VBOWaardecheck: {
        AppraisalRequest: {
          New: {
            noOperation: true,
          },
        },
      },
    },
  });

export default asFlowConditionAppVBOWaardecheckAppraisalRequestNewInput;
